import { useState, useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { formatTime } from "@/lib/format";
import { CheckCircle2, Loader2, DoorOpen } from "lucide-react";

export default function ClosedToday() {
  const { settings } = useAuth();
  const tz = settings?.general?.timezone || "Asia/Dhaka";
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/glitches/closed-today").then(({ data }) => setRows(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="gm-fade-up">
      <div className="flex items-center gap-2 text-[#3a3b45] mb-5">
        <div className="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center text-emerald-600">
          <CheckCircle2 className="w-5 h-5" />
        </div>
        <div>
          <h2 className="font-bold text-lg leading-none">Closed Today</h2>
          <p className="text-xs text-slate-400 mt-1">{rows.length} resolved incident{rows.length !== 1 ? "s" : ""}</p>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-[#4e73df]" /></div>
      ) : rows.length === 0 ? (
        <div className="bg-white rounded-2xl gm-shadow py-20 text-center text-slate-400">
          <p className="font-medium">No incidents closed today yet.</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl gm-shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="closed-table">
              <thead>
                <tr className="bg-slate-50 text-slate-500 text-left text-xs uppercase tracking-wide">
                  <th className="px-4 py-3">#</th>
                  <th className="px-4 py-3">Room</th>
                  <th className="px-4 py-3">Location</th>
                  <th className="px-4 py-3 hidden md:table-cell">Description</th>
                  <th className="px-4 py-3">Closed By</th>
                  <th className="px-4 py-3">Elapsed</th>
                  <th className="px-4 py-3">Closed At</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {rows.map((g) => (
                  <tr key={g.id} className="hover:bg-slate-50/60">
                    <td className="px-4 py-3 font-semibold text-[#4e73df]">{g.serial}</td>
                    <td className="px-4 py-3"><span className="flex items-center gap-1"><DoorOpen className="w-3.5 h-3.5 text-slate-400" />{g.room_no || "-"}</span></td>
                    <td className="px-4 py-3 text-slate-600">{g.location}</td>
                    <td className="px-4 py-3 text-slate-500 max-w-xs truncate hidden md:table-cell">{g.description}</td>
                    <td className="px-4 py-3 text-slate-600">{g.closed_by || "-"}</td>
                    <td className="px-4 py-3 text-slate-500">{g.elapsed || "-"}</td>
                    <td className="px-4 py-3 text-slate-500">{formatTime(g.closed_at, tz)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
